import React, { useMemo } from "react";
import { isSet } from "../../../../Utils/CommonFunctions";
import SwitchItems from "../../../FormBuilder/Builder/FormInputs/SwitchItems";
import { getLayoutFieldsData } from "../../../../Containers/StepsFlowContainer/StepsFunction";

const ResourceInput = ({
  attributes,
  children,
  defProps,
  resource,
  windowMeta,
  fieldPath,
  fieldFormPayload,
  dataElmtStr,
}) => {
  const { matchedField, currentWindowId } = useMemo(() => {
    // Guard inside the hook so hooks order stays stable
    if (!resource || !windowMeta || !fieldPath) {
      return { matchedField: null, currentWindowId: null };
    }

    const currentWindowId = resource.window_id;
    const windowFields = isSet(
      windowMeta.fields_with_filters?.window_fields,
      []
    );
    const fieldIdFromPath = fieldPath.split(".").pop();

    const layoutFormData = getLayoutFieldsData(
      windowFields,
      fieldIdFromPath,
      null
    );

    if (layoutFormData && layoutFormData.isExist === true) {
      return { matchedField: layoutFormData.fieldData, currentWindowId };
    }

    return { matchedField: null, currentWindowId };
  }, [resource, windowMeta, fieldPath]);

  // Early exit after hook so we don't violate hooks rules
  if (!resource || !windowMeta || !fieldPath || !matchedField) {
    return null;
  }
  const reminderDisplayText = "";
  const selectedValue =
    fieldFormPayload[resource.api_name]?.selected_value || dataElmtStr;

  const formFieldsHandler = (obj, e, type = "TextInput") => {
    let fieldValue = null;
    let displayName = null;
    let otherObj = {};

    if (type === "MultiSelect") {
      let MultiSelectValue = [];
      let displayNameText = [];
      e = e === null ? [] : e;
      e.map((item) => {
        MultiSelectValue.push(item.id);
        displayNameText.push(item.value);
        return item;
      });
      displayName = displayNameText.join(",");
      fieldValue = MultiSelectValue.join(",");
    } else if (type === "CheckBoxes") {
      fieldValue = e.target.checked;
    } else if (type === "date") {
      fieldValue = isSet(e, "");
    } else if (["number", "phoneNumber", "PickList"].indexOf(type) !== -1) {
      let getName = "";
      fieldValue = e;
      isSet(matchedField.options, []).map((item) => {
        if (item.id === e) {
          getName = item.value;
        }
        return item;
      });
      displayName = getName;
    } else if (["PickList"].indexOf(type) !== -1) {
      fieldValue = e;
    } else if (["Lookup", "MultiLookup"].indexOf(type) !== -1) {
      fieldValue = e.selectedValue;
      displayName = e.displayValue;
    } else if (type === "Files") {
      fieldValue = e;
    } else if (type === "Reminder") {
      fieldValue = e;
    } else if (type === "currencyType") {
      otherObj = {
        ...otherObj,
        currency_code: e,
      };
      fieldValue = e?.value || e;
    } else {
      fieldValue = e && e.target ? e.target.value : e;
    }

    if (typeof fieldValue === "boolean") {
      fieldValue = fieldValue.toString();
    }

    // let updateObj = {
    //   ...resource,
    //   name: displayName,
    //   value: fieldValue,
    //   data_id: null,
    //   is_loop: false,
    //   is_window_field: true,
    //   is_variable_or_constant: false,
    // };

    // if (otherObj != null) {
    //   updateObj = { ...updateObj, ...otherObj };
    // }

    defProps.onChangeResourcesFieldHandler(resource, fieldValue);
  };

  return (
    <SwitchItems
      {...defProps}
      key={`${attributes.name || matchedField.id}_resource_input`}
      withoutBlock={true}
      validationForms={defProps.validationForms || {}}
      onChangeInputAction={formFieldsHandler}
      modType={"ADDFORM"}
      attributes={attributes}
      item={{
        ...matchedField,
        modType: "ADDFORM",
        selectedValue: selectedValue,
        reminder: selectedValue,
        access_mode: true,
      }}
      isLabel={false}
      reminderDisplayText={reminderDisplayText}
      section={{}}
      windowID={currentWindowId}
      screen={"Pages"}
      layoutForms={true}
    />
  );
};

export default ResourceInput;